<template>
  <div class="content" v-pageBuried data-page-buried="BG_EATWHAT">
    <AppNavbar
      :options="options"
      :title="title"
      :zIndex="1000"
      :placeholder="true"
      v-if="isApp"
    >
      <div slot="right" class="navbar-right">
        <div class="consult" @click="bindConsult">
          <img
            class="hot"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e04a31144d968ccbf8f350937b163fb0.png"
            alt=""
          />
          <img
            class="toast"
            :class="{ 'toast-fadeout': !showToast }"
            v-if="showToastAnimate"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c110ba82b16c21fd113159bcb3cddcaf.png"
            alt=""
          />
          <img
            class="c-avatar"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fd753b6627ee953bfabdc8fd84a70978.png"
            alt=""
          />
        </div>
        <div class="share" @click="bindShare"
          ><span class="iconfont icon-share1"></span
        ></div>
      </div>
    </AppNavbar>
    <div class="app-download" v-if="!isApp">
      <img
        class="app-logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png"
        alt=""
      />
      <div class="center">
        <div class="text1">betterWE App</div>
        <div class="text2">上betterWE，专业营养师帮你挑今天吃什么</div>
      </div>
      <div class="btn">
        <span>打开看看</span>
        <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
      </div>
    </div>
    <div class="wrapper-index">
      <img
        class="c-bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/771e8acadca201ebe15a6d62260f7838.png"
        alt=""
      />
      <div class="wrapper" :class="{ 'wrapper-notapp': !isApp }">
        <img
          class="desc-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f06424ea6c720dc7d6640165ff2d9097.png"
          alt=""
        />
        <div class="nav-container">
          <div class="nav-padding">
            <div class="nav-list">
              <div
                class="nav-item"
                :class="{ 'nav-item-active': index == curIndex }"
                v-for="(item, index) in dayTypeList"
                :key="index"
                @touchend="bindClickNav(index)"
              >
                <div class="item-name">{{ item.name }}</div>
                <div class="item-time">{{ item.time }}</div>
              </div>
              <img
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9fbade76be2c6c5f6afc5d2162dd8b8d.png"
                alt=""
                class="flag"
                :style="{ left: curLeft }"
              />
            </div>
          </div>
          <div class="line"></div>
        </div>
        <div class="food-container">
          <div class="bg-mask" v-if="disableDraw"></div>
          <CardComponent v-model="showResult" :foodType="curFoodType">
            <FoodDetail
              :show="showResult"
              :data="foodData"
              :foodType="curFoodType"
              @order="bindShowOrder"
            />
          </CardComponent>
          <div class="food-box">
            <div class="mask">
              <DrawFood />
            </div>
          </div>
          <DrawLoading class="draw-loading" v-model="showDrawLoading" />
        </div>
        <div class="btn-list">
          <div
            class="btn-item"
            :id="'btn-item-' + index"
            v-for="(item, index) in foodTypeList"
            :key="index"
            v-clickBuried
            :data-click-buried="item.buried"
            @click="bindClick(index)"
          >
            <WxOpenLaunchApp :extinfo="extinfo" v-if="!isApp"></WxOpenLaunchApp>
            <img class="btn-image" :src="item.image" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="banner-wrapper">
      <div
        class="banner-container"
        v-if="isApp && (banner1Data.length || banner2Data.length)"
      >
        <div class="banner-item">
          <img
            class="banner-image"
            v-for="(item, index) in banner1Data"
            :key="index"
            :src="item.img"
            alt=""
            v-buried
            data-buried="BG_EATWHAT_BANNER01"
            v-clickBuried
            :data-eventv="'BG_EATWHAT_BANNER01_' + item.id"
            :data-click-eventv="'CLICK_EATWHAT_BANNER01_' + item.id"
            data-click-buried="CLICK_EATWHAT_BANNER01"
            @click="bindClickBanner(item)"
          />
        </div>
        <div class="banner-item">
          <img
            class="banner-image"
            v-for="(item, index) in banner2Data"
            :key="index"
            :src="item.img"
            alt=""
            v-buried
            data-buried="BG_EATWHAT_BANNER02"
            v-clickBuried
            :data-eventv="'BG_EATWHAT_BANNER02_' + item.id"
            :data-click-eventv="'CLICK_EATWHAT_BANNER02_' + item.id"
            data-click-buried="CLICK_EATWHAT_BANNER02"
            @click="bindClickBanner(item)"
          />
        </div>
      </div>
    </div> -->
    <img
      class="logo"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
      alt=""
    />
    <!-- 点外卖 -->
    <van-overlay
      :show="showOrder"
      @click.stop="showOrder = false"
      z-index="2000"
    >
      <OrderPopup
        v-if="showOrder"
        @close="bindHideOrder"
        :jumpHema="foodData.jump_hema"
        :takeAway="foodData.is_allow_takeaway"
      />
    </van-overlay>
    <!-- 分享组件 -->
    <van-overlay :show="showShare" @click="showShare = false" z-index="2003">
      <ShareComponent
        v-if="showShare"
        class="share-container"
        @close="bindCloseShare"
        @link="bindClickLink"
        @image="bindClickImage"
        :copyUrl="qrcodeUrl"
        :linkShareIcon="linkShareIcon"
      />
    </van-overlay>
    <MyToast
      v-show="toastData.show"
      :title="toastData.title"
      :desc="toastData.desc"
      :confirmText="toastData.confirmText"
      :image="toastData.image"
      @confirm="toastData.confirm"
      @cancel="toastData.cancel"
    ></MyToast>
  </div>
</template>
<script>
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import MyToast from '@/components/app/toast/confirm-toast.vue'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import DrawFood from './components/draw-food.vue'
import CardComponent from './components/card.vue'
import FoodDetail from './components/result.vue'
import OrderPopup from './components/order.vue'
import ShareComponent from '@/components/app/share'
import DrawLoading from './components/loading.vue'
import { hemaBtn, defaultBanner } from './components/data'
export default {
  name: 'eating-today-home',
  components: {
    AppNavbar,
    DrawFood,
    CardComponent,
    FoodDetail,
    OrderPopup,
    ShareComponent,
    MyToast,
    DrawLoading,
    WxOpenLaunchApp
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'transparent',
        color: 'rgba(0,0,0,0.8)'
      },
      title: '',
      extinfo: '',
      linkShareIcon: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
          name: '复制链接'
        }
      ],
      foodTypeList: [
        {
          name: '外卖',
          type: 2,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5781c70119ee335abad139e4fdb36058.png',
          buried: 'CLICK_CHOUWAIMAI' //埋点事件名称
        },
        {
          name: '自制',
          type: 1,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/feac7895f2d2caf742a67fa8bbb6bf01.png',
          buried: 'CLICK_CHOUZIZHI' //埋点事件名称
        },
        {
          name: '零食',
          type: 3,
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a8370bd5fb76b05e7d139a90a465a672.png',
          buried: 'CLICK_CHOULINGSHI' //埋点事件名称
        }
      ],
      curIndex: 0,
      curFoodType: 0,
      disableDraw: false, //禁用抽取食物
      showOrder: false,
      dayTypeList: [
        {
          name: '早餐',
          type: 1,
          time: '6:00 - 10:00'
        },
        {
          name: '午餐',
          type: 2,
          time: '10:00 - 13:00'
        },
        {
          name: '下午茶',
          type: 3,
          time: '13:00 - 16:30'
        },
        {
          name: '晚餐',
          type: 4,
          time: '16:30 - 20:30'
        }
      ],
      showResult: false,
      lotteryData: null,
      foodData: null,
      showToast: false, //是否显示资讯营养师弹窗
      showToastAnimate: false,
      curDrawCount: 0, //当前抽取次数
      showShare: false,
      qrcodeUrl: '',
      pageData: null,
      toastData: {
        show: false,
        title: '温馨提示',
        desc: '',
        confirmText: '好的',
        image:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8592eb71d91be138e78c0eb373cd16b7.png',
        confirm: () => {},
        cancel: () => {}
      },
      isApp: false,
      banner1Data: [],
      banner2Data: [],
      showDrawLoading: false
    }
  },
  watch: {
    showToast() {
      if (!this.showToast) {
        setTimeout(() => {
          this.showToastAnimate = false
        }, 1000)
      } else {
        return (this.showToastAnimate = true)
      }
    }
  },
  computed: {
    curLeft() {
      let space = 100 / this.dayTypeList.length
      return space * this.curIndex + space / 2 + '%'
    }
  },
  created() {
    this.isApp = this.$betterwe.isApp()
    let curUrl = location.origin + location.pathname
    this.extinfo = '/web?url=' + encodeURIComponent(curUrl)
    this.qrcodeUrl = curUrl
    this.curIndex = this.computedCurTime()
    this.getData()
    /*  if (this.isApp) {
      this.getBannerData();
    } */
    if (this.$http.getEnv() != 'pro') {
      this.$betterwe.requestLocation().then((res) => {
        if (res.errorCode == 0) {
          console.log('获取到经纬度', res)
        }
      })
    }
  },
  mounted() {
    this.addScrollEvent()
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    getBannerData() {
      let params1 = {
        position_type: '24', //位置类型
        resource_type: '15' //资源位类型
      }
      let params2 = {
        position_type: '24', //位置类型
        resource_type: '16' //资源位类型
      }
      let promise1 = this.$http.getAdvData(
        'member/ResourceLocation/getShowResourceLocationNew',
        params1
      )
      let promise2 = this.$http.getAdvData(
        'member/ResourceLocation/getShowResourceLocationNew',
        params2
      )
      Promise.all([promise1, promise2])
        .then((arr) => {
          if (arr[0].data.code == 200 && arr[1].data.code == 200) {
            if (arr[0].data.data && arr[0].data.data.length) {
              this.banner1Data = arr[0].data.data
            }
            if (arr[1].data.data && arr[1].data.data.length) {
              this.banner2Data = arr[1].data.data
            }
          }
        })
        .catch((err) => {})
        .finally(() => {
          if (!this.banner1Data.length) {
            this.banner1Data = defaultBanner.banner1Data
          }
          if (!this.banner2Data.length) {
            this.banner2Data = defaultBanner.banner2Data
          }
        })
    },
    bindShare() {
      if (this.disableDraw) {
        return
      }
      this.showShare = true
    },
    bindClickNav(index) {
      if (this.disableDraw) {
        return
      }
      this.curIndex = index
    },
    getData() {
      this.$http.postBaseApp('member/todayDiet/index', {}).then((res) => {
        res = res.data
        if (res.code == 200) {
          this.pageData = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
    //根据当前时间计算早午晚餐类型
    computedCurTime() {
      let timeDuration = [
        {
          name: '早餐',
          duration: '6-10', //时间段
          start: 1000 * 60 * 60 * 6, //今日凌晨到该点的毫秒数
          end: 1000 * 60 * 60 * 10 //今日凌晨到该点的毫秒数
        },
        {
          name: '中餐',
          duration: '10-13',
          start: 1000 * 60 * 60 * 10,
          end: 1000 * 60 * 60 * 13
        },
        {
          name: '下午茶',
          duration: '13-16.30',
          start: 1000 * 60 * 60 * 13,
          end: 1000 * 60 * 60 * 16.5
        },
        {
          name: '晚餐',
          duration: '16.30-20.30',
          start: 1000 * 60 * 60 * 16.5,
          end: 1000 * 60 * 60 * 20.5
        }
      ]
      let index = 0
      //当前时间 - 当日凌晨时间
      let curTime =
        new Date().getTime() -
        new Date(new Date().toLocaleDateString()).getTime()
      for (let i = 0; i < timeDuration.length; i++) {
        if (curTime >= timeDuration[i].start && curTime < timeDuration[i].end) {
          index = i
          break
        }
      }
      return index
    },
    //抽取食物
    async bindClick(index) {
      if (this.disableDraw || !this.isApp) {
        return
      }
      let el = document.getElementById('btn-item-' + index)
      el.className = 'btn-item btn-item-active'
      setTimeout(() => {
        el.className = 'btn-item'
      }, 700)
      this.showResult = false
      let drawType = this.foodTypeList[index].type
      let dietType = this.dayTypeList[this.curIndex].type
      let params = {
        diet_type: dietType,
        type: drawType
      }
      this.showDrawLoading = true
      this.disableDraw = true
      let res
      if (this.pageData.is_jump) {
        res = await this.$http
          .post(
            'https://prebtapp.gymcity.com.cn/member/todayDiet/drawFood',
            params
          )
          .catch(() => {
            this.$toast.clear()
            this.disableDraw = false
          })
          .finally(() => {
            this.showDrawLoading = false
          })
      } else {
        res = await this.$http
          .postBaseApp('member/todayDiet/drawFood', params)
          .catch(() => {
            this.$toast.clear()
            this.disableDraw = false
          })
          .finally(() => {
            this.showDrawLoading = false
          })
      }
      if (res) {
        res = res.data
        this.$toast.clear()
        if (res.code != 200) {
          this.disableDraw = false
        }
        if (res.code == 200) {
          this.curFoodType = index
          this.lotteryData = res.data
          let detail =
            res.data.food_type == 3
              ? res.data.food_detail.super_food
              : res.data.food_detail
          this.foodData = this.filterFoodData(
            detail,
            res.data.food_type,
            drawType,
            res.data.jump_detail
          )
          this.bindShowResult()
          this.computedShowToast()
          setTimeout(() => {
            this.disableDraw = false
          }, 1000)
        } else if (res.code == 700) {
          //未登录
          this.$betterwe.isLogin(() => {
            this.bindClick(index)
          })
        } else if (res.code == 1000) {
          //使用次数已经用完
          if (this.pageData?.is_weplus) {
            this.bindShowUseEnd()
          } else {
            this.bindShowBuy()
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    //次数用完显示购买会员
    bindShowBuy() {
      this.toastData.desc = `<div style='font-size: 14px;color: rgba(0,0,0,0.6);line-height: 24px;margin-bottom:8px'>您今日抽取次数已用完, 请明日再来</div>
            <div style='font-size: 14px;font-weight: 600;color: rgba(0,0,0,0.8);line-height: 20px;'>升级 <span style="position:relative;z-index:1">WE+减脂会员<span
              style='position:absolute;left:0;bottom:2px;width: 100%;height: 6px;background: #FFDDBE;border-radius: 3px;z-index:-1' ></span></span><br/>畅享无限次抽取</div>`
      this.toastData.confirmText = '查看WE+减脂会员权益'
      this.toastData.confirm = async () => {
        this.toastData.show = false
        let version = await this.$betterwe.getAppVersion()
        if (version >= 98) {
          this.$betterwe.vipHomePage()
        } else {
          this.$router.push('/betterwe/vip')
        }
      }
      this.toastData.cancel = () => {
        this.toastData.show = false
      }
      this.toastData.show = true
    },
    //次数用完提示
    bindShowUseEnd() {
      this.toastData.desc = `您今日抽取次数已用完, 请明日再来`
      this.toastData.confirmText = '好的'
      this.toastData.confirm = () => {
        this.toastData.show = false
      }
      this.toastData.cancel = () => {
        this.toastData.show = false
      }
      this.toastData.show = true
    },
    //计算是否显示弹框 1天只曝光2次，每抽3次出现1次 展示时长为3.5秒。
    computedShowToast() {
      this.curDrawCount++
      if (this.curDrawCount >= 3) {
        this.curDrawCount = 0
        let count = this.getStorageCount()
        if (count < 2) {
          this.showToast = true
          this.setStorageCount(count + 1)
          setTimeout(() => {
            this.showToast = false
          }, 3500)
        }
      }
    },
    //获取弹框显示次数
    getStorageCount() {
      let count = localStorage.getItem('eating-today-v2-showToast')
      if (count) {
        //当日凌晨时间
        let time = new Date(new Date().toLocaleDateString()).getTime()
        let arr = count.split('_')
        //保存的时间戳不是当天时间凌晨则重置为0
        return arr[0] == time ? +arr[1] : 0
      } else {
        return 0
      }
    },
    //设置弹框显示次数
    setStorageCount(count) {
      //当日凌晨时间
      let time = new Date(new Date().toLocaleDateString()).getTime()
      localStorage.setItem('eating-today-v2-showToast', time + '_' + count)
    },
    getFoodData() {
      let foodType = this.lotteryData.food_type
      let id = this.lotteryData.food_id
      this.disableDraw = true
      this.showDrawLoading = true
      switch (foodType) {
        case 1:
          this.getSuperMenu(id, foodType)
          break
        case 2:
          this.getFoodDetail(id, foodType)
          break
        case 3:
          this.getFoodSuperDetail(id, foodType)
          break
      }
    },
    //获取超级菜谱
    getSuperMenu(id, foodType) {
      let params = {
        super_recipe_id: id
      }
      this.$http
        .postBaseApp('member/SuperRecipe/getSuperRecipeDetail', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.foodData = this.filterFoodData(res.data, foodType)
            this.bindShowResult()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          setTimeout(() => {
            this.disableDraw = false
          }, 1000)
        })
    },
    //获取食物详情
    getFoodDetail(id, foodType) {
      let params = {
        foodid: id
      }
      this.$http
        .postApp('facility/calorie/FoodDetail', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.foodData = this.filterFoodData(res.data, foodType)
            this.bindShowResult()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          setTimeout(() => {
            this.disableDraw = false
          }, 1000)
        })
    },
    //获取超级食物详情
    getFoodSuperDetail(id, foodType) {
      let params = {
        foodid: id
      }
      this.$http
        .postApp('member/Foods/superFood', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.foodData = this.filterFoodData(res.data.super_food, foodType)
            this.bindShowResult()
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          setTimeout(() => {
            this.disableDraw = false
          }, 1000)
        })
    },
    bindShowResult() {
      this.showDrawLoading = false
      this.showResult = true
    },
    //处理后端三个接口返回的数据变成统一的参数
    filterFoodData(data, foodType, drawType, starInfo) {
      let obj = Object.assign({}, data)
      obj.foodType = foodType
      obj.desc =
        '加餐零食需要遵循不饿不吃的基本原则哦，每天最多吃1次，摄入量要控制在100大卡以内～'
      obj.coachInfo = starInfo
      if (foodType == 1) {
        //超级菜谱
        obj.foodName = data.name
        obj.foodImage = data.icon
        // obj.coachInfo = data.dietitian_info
        obj.kcal = Math.floor(data.total_quantity_heat) || 0
        obj.desc = data.desc
        obj.features = data.recommend_desc
        obj.star = data.difficulty_degree
        obj.makeTime = data.make_stime + '-' + data.make_etime + '分钟'
      } else if (foodType == 2) {
        //普通食物
        obj.foodName = data.name
        obj.foodImage = data.image
        // obj.coachInfo = defaultCoahInfo
        obj.kcal = Math.floor(data.calorie && data.calorie.cal) || 0
        obj.features = ''
        obj.star = ''
        obj.makeTime = ''
        obj.stapeFood = ''
      } else if (foodType == 3) {
        //超级食物
        obj.foodName = data.s_food_name
        obj.foodImage = data.s_image
        obj.kcal = Math.floor(data.calory) || 0
        obj.features = ''
        obj.star = ''
        obj.makeTime = ''
        obj.stapeFood = ''
      }
      //抽取类型为零食时
      if (drawType == 3 && data.recommendation) {
        obj.desc = data.recommendation
      }
      return obj
    },
    bindShowOrder() {
      if (!this.foodData.is_allow_takeaway && this.foodData.jump_hema) {
        this.bindHideOrder(hemaBtn[0])
      } else {
        this.showOrder = true
      }
    },
    //关闭外卖弹框
    async bindHideOrder(item) {
      this.showOrder = false
      if (!item) {
        return
      }
      let version = await this.$betterwe.getAppVersion()
      let text = '正在为您跳转' + item.toast
      this.jumpToastText = text
      this.showJumpToast = true
      setTimeout(() => {
        this.showOrder = false
        this.showJumpToast = false
        setTimeout(() => {
          if (version < 90) {
            this.$betterwe.jumpMiniProgram({
              appId: item.username,
              path: encodeURIComponent(item.path + this.foodData.foodName)
            })
          } else {
            let appPath =
              item.launchUrlApp + (item.id == 1 ? this.foodData.foodName : '')
            if (item.id == 1) {
              //美团则优先跳转app
              this.$betterwe.launchUrlApp(appPath, (res) => {
                if (!+res) {
                  //如果res = 0 跳转app失败则跳转小程序
                  this.$betterwe.jumpMiniProgram({
                    appId: item.username,
                    path: encodeURIComponent(item.path + this.foodData.foodName)
                  })
                }
              })
            } else {
              //其他默认跳转小程序
              this.$betterwe.jumpMiniProgram({
                appId: item.username,
                path: encodeURIComponent(item.path + this.foodData.foodName)
              })
            }
          }
        }, 300)
      }, 700)
    },
    bindCloseShare() {
      this.showShare = false
    },
    bindClickImage(index) {},
    bindClickLink(index) {
      switch (index) {
        case 0:
          this.shareFriend()
          break
        case 1:
          this.shareWechatCicle()
          break
        case 2:
          this.showShare = false
          break
      }
    },
    //分享到微信好友
    shareFriend() {
      console.log('链接分享到微信好友')
      let obj = {
        shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
        contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
        // 分享的数据
        shareData: {
          data: this.qrcodeUrl, //分享的链接
          //分享的数据的格 式
          //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
          type: 'url',
          desc: '超好吃的营养师严选减脂菜单，一键抽取，解决你的难题！',
          title: '不知道今天吃什么？',
          thumbnail:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_logo.png' // 分享的缩略图的url
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信朋友圈
    shareWechatCicle() {
      console.log('链接分享到微信朋友圈')
      let obj = {
        shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
        contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
        // 分享的数据
        shareData: {
          data: this.qrcodeUrl, //分享的链接
          //分享的数据的格 式
          //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
          type: 'url',
          desc: '超好吃的营养师严选减脂菜单，一键抽取，解决你的难题！',
          title: '不知道今天吃什么？',
          thumbnail:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_logo.png' // 分享的缩略图的url
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信
    shareWechat(obj) {
      if (this.$http._isApp()) {
        this.$betterwe.onAppShare(obj)
      }
    },
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset

      if (scrollTop >= 100) {
        this.title = '今天吃什么'
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, 1)',
          color: 'rgba(0,0,0,0.8)'
        }
      } else {
        this.title = ''
        let p = parseFloat((scrollTop / 100).toFixed(2))
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, ' + p + ')',
          color: 'rgba(0,0,0,0.8)'
        }
      }
    },
    bindClickBanner(item) {
      if (this.disableDraw) {
        return
      }
      if (this.$http._isApp()) {
        item.router && this.$betterwe.onAppPageRoute(item.router)
      }
    },
    jumpDownloadPage() {
      if (!this.$http._isApp()) {
        location.href = 'https://member3.gymcity.com.cn/#/app-download'
        return true
      }
    },
    bindConsult() {
      if (this.disableDraw) {
        return
      }
      //营养师咨询入口点击
      this.$buryPoint('CLICK_EATWHAT_ZX', {})
      this.jumpDownloadPage()
      if (this.$http._isApp()) {
        this.$http.sendUserAct(8)
        let path =
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F9e7e28d5be08a56c56a54e113da4524d.png'
        this.$betterwe.jumpRoute(path)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  background: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f28dcd50436f44bc340ae6aec822ba9b.png')
      no-repeat,
    linear-gradient(
      180deg,
      #d0eaff 0%,
      #def0ff 76%,
      rgba(221, 240, 255, 0) 100%
    );
  box-sizing: border-box;
  background-size: 100%;
  min-height: 100vh;
  padding-bottom: 20px;
  box-sizing: border-box;
}

.wrapper-index {
  margin: 77px 16px 26px;
  width: 343px;
  position: relative;
  z-index: 0;

  .c-bg {
    position: absolute;
    width: 375px;
    left: 50%;
    top: -158px;
    transform: translate(-50%, 0%);
    z-index: -1;
  }

  .wrapper {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    padding-bottom: 20px;
    position: relative;
    z-index: 2;

    .desc-image {
      width: 100%;
      height: 30px;
      margin-bottom: 4px;
    }

    .nav-container {
      margin-bottom: 12px;

      .nav-padding {
        padding: 0 8px;

        .nav-list {
          position: relative;
          margin-bottom: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .nav-item {
            flex: 1;
            text-align: center;
            position: relative;
            color: rgba(0, 0, 0, 0.5);

            .item-name {
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              line-height: 22px;
              transition: transform 0.3s ease;
            }

            .item-time {
              font-size: 8px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              line-height: 14px;
              transition: transform 0.3s ease;
            }
          }

          .nav-item::after {
            content: '';
            z-index: 1;
            border-radius: 50%;
            position: absolute;
            left: 50%;
            bottom: -14px;
            width: 8px;
            height: 8px;
            transform: translate(-50%, 50%);
            background: #cde7ff;
            border: 1px solid #ffffff;
          }

          .nav-item-active {
            color: rgba(0, 0, 0, 0.8);

            .item-name {
              transform: scale(1.33);
            }

            .item-time {
              transform: scale(1.25);
            }
          }

          .flag {
            width: 20px;
            height: 20px;
            transform: translate(-50%, 50%);
            position: absolute;
            bottom: -14px;
            z-index: 5;
            transition: left 0.2s ease;
          }
        }
      }

      .line {
        width: 100%;
        height: 1.5px;
        background: linear-gradient(
          117deg,
          #ffffff 0%,
          #d7ecff 14%,
          #d7ecff 86%,
          #ffffff 100%
        );
        opacity: 0.8;
      }
    }

    .food-container {
      position: relative;
      width: 319px;
      height: 410px;
      margin: 0 auto 20px;

      .bg-mask {
        border-radius: 8px;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        background-color: rgba(0, 0, 0, 0.3);
        animation: maskAnimation 1s linear;
      }

      .draw-loading {
        z-index: 5;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .food-box {
      position: relative;
      z-index: 1;
      width: 319px;
      height: 410px;

      .mask {
        border-radius: 8px;
        border: 1px solid #ffffff;
        position: absolute;
        z-index: 1;
        overflow: hidden;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        left: 0;
        top: 0;
        background: linear-gradient(170deg, #73ecd2 0%, #5ebaf8 100%);
      }

      .mask::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        box-shadow: inset 0px 1px 5px rgba(10, 15, 135, 0.19);
      }
    }

    .btn-list {
      width: 303px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn-item {
        width: 90px;
        height: 60px;
        position: relative;
        border-radius: 12px;

        .btn-image {
          width: 100%;
          height: 100%;
        }
        .btn-flag {
          position: absolute;
          right: 10px;
          top: -8px;
          width: 35px;
          height: 15px;
          z-index: 1;
        }
      }

      .btn-item-active {
        animation: scaleBtn 0.6s linear;
      }

      .btn-item:first-child {
        box-shadow: 0px 2px 12px 0px rgba(193, 137, 61, 0.24),
          inset 0px -1px 4px 0px rgba(255, 255, 255, 0.38);
      }

      .btn-item:nth-child(2) {
        box-shadow: 0px 2px 12px 0px rgba(75, 154, 226, 0.24),
          inset 0px -1px 2px 0px rgba(255, 255, 255, 0.55);
      }

      .btn-item:nth-child(3) {
        box-shadow: 0px 2px 12px 0px rgba(68, 196, 149, 0.53),
          inset 0px -1px 2px 0px rgba(255, 255, 255, 0.5);
      }
    }
  }

  .wrapper-notapp {
    margin: 77px auto 10px;
  }
}

.banner-wrapper {
  overflow: hidden;
  margin-bottom: 20px;

  .banner-container {
    margin: 0 auto;
    width: 343px;
    height: 108px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .banner-item {
      width: 168px;
      height: 108px;

      .banner-image {
        border-radius: 8px;
        overflow: hidden;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.logo {
  margin: 0 auto 20px;
  height: 16px;
}

.navbar-right {
  display: flex;
  align-items: center;

  .consult {
    margin-right: 22px;
    position: relative;

    .hot {
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(60%, -20%);
      width: 20px;
      height: 11px;
      object-fit: contain;
    }

    .toast {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translate(-50%, 0%);
      width: 84px;
      height: 42px;
      object-fit: contain;
      animation: fadeIn 1s ease;
      z-index: 2;
    }

    .toast-fadeout {
      animation: fadeout 1s ease;
    }

    .c-avatar {
      box-sizing: border-box;
      width: 30px;
      height: 30px;
      border-radius: 15px;
      border: 1px solid #ffffff;
    }
  }

  .share {
    .iconfont {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.8);
      font-size: 600;
    }
  }
}

.share-container {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
}

.app-download {
  width: 100%;
  position: sticky;
  z-index: 3;
  top: 0;
  padding: 0 15px;
  box-sizing: border-box;
  height: 44px;
  display: flex;
  align-items: center;
  background: linear-gradient(
    270deg,
    rgba(36, 39, 89, 0.27) 0%,
    rgba(34, 37, 71, 0.49) 100%
  );

  .app-logo {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    margin-right: 5px;
  }

  .center {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;

    .text1 {
      font-size: 11px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 16px;
    }

    .text2 {
      font-size: 8px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(255, 255, 255, 0.9);
      line-height: 11px;
    }
  }

  .btn {
    position: relative;
    text-align: center;
    width: 60px;
    height: 22px;
    background: #6236ff;
    border-radius: 11px;
    font-size: 10px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 22px;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes scaleBtn {
  0% {
    transform: scale(1);
  }

  33.33% {
    transform: scale(0.8);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes maskAnimation {
  0% {
    background-color: rgba(0, 0, 0, 0.1);
  }

  100% {
    background-color: rgba(0, 0, 0, 0.3);
  }
}
</style>
